import z from "zod/v3";

export const EmailOtpSchema = z.object({
	code: z.string().min(6).max(6),
});
